import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconExtension$1 = /*@__PURE__*/ proxyCustomElement(class WppIconExtension extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-extension", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M10.9925 2C12.271 2 13.3161 2.99943 13.3884 4.25589L13.3924 4.39651L15.1938 4.39731C15.8877 4.39731 16.4637 4.90204 16.5748 5.56452L16.5895 5.68299L16.5942 5.79787L16.5934 8.79956L14.9949 8.79965C14.3998 8.79965 13.9016 9.23432 13.8106 9.79117L13.7983 9.89694L13.7945 10C13.7945 10.595 14.2292 11.0933 14.786 11.1843L14.8918 11.1965L14.9948 11.2004L16.5934 11.2003L16.5942 14.2023C16.5942 14.937 16.0283 15.5396 15.3085 15.598L15.1937 15.6027L13.3924 15.6022L13.3892 15.7404C13.3216 16.9054 12.4234 17.8475 11.278 17.9832L11.1336 17.9959L10.9925 18C9.714 18 8.66891 17.0006 8.5959 15.743L8.59182 15.6022L6.79129 15.6027C6.09736 15.6027 5.52131 15.098 5.41023 14.4357L5.39553 14.3173L5.39088 14.2024L5.39008 12.4005L5.25964 12.3966C4.09465 12.3291 3.15251 11.4309 3.0168 10.2855L3.00408 10.1411L3 10C3 8.72148 3.99943 7.67639 5.25959 7.60337L5.39008 7.59905L5.39088 5.79772C5.39088 5.10379 5.89561 4.52774 6.55787 4.41666L6.67631 4.40196L6.79114 4.39731L8.59102 4.39651L8.5959 4.25964C8.6634 3.09464 9.56163 2.15251 10.707 2.0168L10.8515 2.00408L10.9925 2ZM10.9925 3.20035C10.3686 3.20035 9.85583 3.6764 9.79767 4.28559L9.79217 4.40129L9.791 5.5969L6.79129 5.59766C6.69659 5.59766 6.61725 5.66347 6.59652 5.75194L6.59123 5.79787L6.59051 8.79953L5.4007 8.79965C4.73777 8.79965 4.20035 9.33706 4.20035 10C4.20035 10.6239 4.6764 11.1367 5.28505 11.1949L5.40064 11.2004L6.59051 11.2002L6.59123 14.2023C6.59123 14.297 6.65704 14.3763 6.74537 14.3971L6.79122 14.4023L9.791 14.402L9.79217 15.5993C9.79217 16.2622 10.3296 16.7996 10.9925 16.7996C11.6165 16.7996 12.1292 16.3236 12.1874 15.7154L12.1929 15.5999L12.1917 14.402L15.1938 14.4023C15.2885 14.4023 15.3678 14.3365 15.3885 14.2482L15.3938 14.2024L15.393 12.3997L14.9747 12.4004L14.8311 12.3952C13.6217 12.3134 12.6672 11.3409 12.5985 10.1215L12.5945 9.97979L12.5997 9.83624C12.6815 8.62685 13.654 7.67234 14.8552 7.6033L14.9948 7.5993L15.393 7.59905L15.3938 5.79772C15.3938 5.72196 15.3517 5.65603 15.2896 5.62208L15.2395 5.60295L15.1936 5.59766L12.1917 5.5969L12.1929 4.4007C12.1929 3.73777 11.6555 3.20035 10.9925 3.20035Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-extension-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-extension", "wpp-icon-extension-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-extension-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-extension-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconExtension$1);
      }
      break;
  } });
}

const WppIconExtension = WppIconExtension$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconExtension, defineCustomElement };
